import React from 'react';
import { Skeleton, Stack } from '@mui/material';

type SuggestionSkeletonProps = {
  lines?: number;
};

/**
 * Shimmer placeholder shown while AI suggestions are being generated.
 * Rendered inline inside the card in place of the suggested content.
 */
const SuggestionSkeleton = ({ lines = 2 }: SuggestionSkeletonProps) => (
  <Stack spacing={0.75}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        variant="rounded"
        height={12}
        width={i === lines - 1 ? '60%' : '100%'}
        animation="wave"
      />
    ))}
  </Stack>
);

export default SuggestionSkeleton;
